export default "__VITE_ASSET__DUW61Tj___"